module.exports = __webpack_public_path__ + "media/dripcelebs.bc8f3c12.mp4";